import VueI18n, { LocaleMessageObject, LocaleMessages } from 'vue-i18n';

// add new languages here
const availableLocales = [
  'de_DE',
  'de_AT',
  'de_CH',
  'de_LU',
  'en_US',
  'en_CA',
  'cs_CZ',
  'da_DK',
  'el_GR',
  'en_GB',
  'en_IE',
  'en_XH',
  'en_MY',
  'en_SG',
  'es_ES',
  'fi_FI',
  'fr_CH',
  'fr_BE',
  'fr_FR',
  'fr_LU',
  'fr_CA',
  'hu_HU',
  'ko_KR',
  'it_IT',
  'it_CH',
  'nl_NL',
  'nl_BE',
  'pl_PL',
  'pt_PT',
  'ro_RO',
  'sk_SK',
  'sv_SE',
  'tr_TR',
  'zh_TW',
];
// define the fallback order to translate missing keys
const fallbacks = ['de_DE', 'en_US'];

const getTranslations = (): LocaleMessages => {
  const translations: { [key: string]: LocaleMessageObject } = {};
  availableLocales.forEach((lang) => {
    translations[lang] = require(`./files/${lang}.json`);
  });
  return translations;
};

export const getConfigByLocale = (locale: string): VueI18n => {
  return new VueI18n({
    locale,
    fallbackLocale: fallbacks,
    messages: { ...getTranslations() },
  });
};
